import { MeRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import eventManager from 'common/services/-RFC.eventManager';

const _directiveDependencies = [];
const _controllerDependencies = ['$state'];

class UserInfoController {

    constructor($state) {

        this.$state = $state;
        this.User = MeRepository.getMyUser();

        // MeRepository Observable
        const meRepositoryObservable = MeRepository.getObservable();
        const onNextMeRepository = () => {

            // get user from MeRepository
            this.User = MeRepository.getMyUser();

        };

        // trigger onNextMeRepository() on MeRepository update
        this.meRepositorySubscriber = meRepositoryObservable.subscribe(
            onNextMeRepository,
            () => { },
            () => { },
        );

    }

    changePicture() {

        Mixpanel.send('ConnectWeb User Icon Click');
        eventManager.broadcast('user-menu:clicked');
        this.$state.go('root.dashboard.my-account', { tab: 'profile' });

    }

}

class UserInfoDirective {

    constructor() {

        this.template = require('./user-info.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($state, $scope) =>
            new UserInfoController($state, $scope));
        this.controller = _controllerDependencies;
        this.controllerAs = 'userInfoCtrl';

    }

}


_directiveDependencies.push(() => new UserInfoDirective());

angular.module('directives')
    .directive('userInfo', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/header/user-info/user-info.js